<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [key]="key"
             class="next-payment-method-section"
             [formGroup]="formGroup"
             [title]="title">

  <ng-template #section>

    <app-radio-checkbox-tile [content]="radioCheckboxTileContent"
                             [contentData]="paymentMethodsService.allowedMethodsConfig"
                             [bean]="bean"
                             [errorsMap]="formFactoryService.errorsMap"
                             [control]="formGroup.controls[SectionFieldKey.PAYMENT_METHOD]"
                             [fieldConfig]="formFactoryService.fieldConfig(SectionFieldKey.PAYMENT_METHOD, formConfig)"
                             (changeEvent)="onFieldChange($event)"
                             [context]="formConfig.formKey"
                             (interactiveClick)="parentSection.sendCheckoutElementClickEvent($event)">
    </app-radio-checkbox-tile>

    <ng-template #radioCheckboxTileContent let-data="data">
      <div [class]="'payment-method-tile-content ' + getPaymentMethodTileContentCssClass(data.method)"
           [ngClass]="{'payment-method-tile-content--no-label': !data.label || !data.displayLabel}">
        <div class="payment-method-tile-content__left">
          <div *ngIf="data.label && data.displayLabel"
               class="payment-method-tile-content__label">
            {{ data.label | translate }}
          </div>
          <div *ngIf="data.leftImage"
               class="payment-method-tile-content__left-image">
            <img [src]="data.leftImage">
          </div>
        </div>

        <div *ngIf="data.rightImage"
             class="payment-method-tile-content__right">
          <img [src]="data.rightImage">
        </div>
      </div>
    </ng-template>

    <div class="next-payment-method-section__contract-info">
      {{ contractInfo | translate }}
    </div>

  </ng-template>

</app-section>
